import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ScrollView } from "native-base";
import Card from "../atoms/Card/Card";
import CommentListItem from "./ListItem/CommentListItem";
const CommentListCard = ({ comments, setCommentState }) => {
    const onDelete = (comment) => {
        if (setCommentState) {
            setCommentState((ps) => (Object.assign(Object.assign({}, ps), { onShow: false })));
        }
        comment.onDeleted();
    };
    return (comments === null || comments === void 0 ? void 0 : comments.length) ? (_jsx(Card, Object.assign({ flex: 0, px: 0, py: 0, width: 92, shadow: 8 }, { children: _jsx(ScrollView, Object.assign({ maxHeight: 80 }, { children: comments.map((item, index) => (_jsx(CommentListItem, Object.assign({}, item, { onDeleted: () => onDelete(item), borderBottomWidth: index === comments.length - 1 ? 0 : 1 }), `comment-list-item-${index}`))) })) }))) : (_jsx(_Fragment, {}));
};
export default CommentListCard;
